export enum CalculatorType {
  PROBATE = 'probate',
  BOND = 'bond',
  FINAL_TAXES = 'final_taxes'
}
